<template>
	<DaModalFrame v-model:open="modalIsOpen" :disableClose="true">
		<LoadingDowloadPDF :text="'Đang xử lý dữ liệu...'" />
	</DaModalFrame>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 side-over">
		<div class="h-full w-full flex flex-col bg-white shadow-xl">
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center" @click="$emit('close')">
						<svg
							width="18"
							height="24"
							viewBox="0 0 18 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M0 3C0 1.34315 1.34315 0 3 0H10.9393C11.3372 0 11.7187 0.158035 12 0.43934L17.5607 6C17.842 6.28131 18 6.66284 18 7.06066V21C18 22.6569 16.6569 24 15 24H3C1.34315 24 0 22.6569 0 21V3ZM11.25 5.25V2.25L15.75 6.75H12.75C11.9216 6.75 11.25 6.07843 11.25 5.25ZM9.75 10.5C9.75 10.0858 9.41421 9.75 9 9.75C8.58579 9.75 8.25 10.0858 8.25 10.5V12.75H6C5.58579 12.75 5.25 13.0858 5.25 13.5C5.25 13.9142 5.58579 14.25 6 14.25H8.25V16.5C8.25 16.9142 8.58579 17.25 9 17.25C9.41421 17.25 9.75 16.9142 9.75 16.5V14.25H12C12.4142 14.25 12.75 13.9142 12.75 13.5C12.75 13.0858 12.4142 12.75 12 12.75H9.75V10.5Z"
								fill="#94A3B8"
							/>
						</svg>
						<div class="text-2xl font-bold text-neutral-700 ml-2">
							Tạo Đánh giá phát triển
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							type="button"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								aria-hidden="true"
								class="h-6 w-6"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M6 18L18 6M6 6l12 12"
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div class="sideover-content mt-6 relative flex-1 px-4 sm:px-6">
				<!-- <div class="rounded-md bg-orange-50 p-4">
					<div class="flex items-center gap-3">
						<div class="flex-shrink-0">
							<svg
								fill="none"
								height="20"
								viewBox="0 0 20 20"
								width="20"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clip-path="url(#clip0_19328_29044)">
									<path
										d="M10.0003 18.3327C14.6027 18.3327 18.3337 14.6017 18.3337 9.99935C18.3337 5.39698 14.6027 1.66602 10.0003 1.66602C5.39795 1.66602 1.66699 5.39698 1.66699 9.99935C1.66699 14.6017 5.39795 18.3327 10.0003 18.3327Z"
										stroke="#F59F0A"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
									/>
									<path
										d="M10 13.3333V10"
										stroke="#F59F0A"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
									/>
									<path
										d="M10 6.66602H10.0083"
										stroke="#F59F0A"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
									/>
								</g>
								<defs>
									<clipPath id="clip0_19328_29044">
										<rect
											fill="white"
											height="20"
											width="20"
										/>
									</clipPath>
								</defs>
							</svg>
						</div>
						<div class="text-sm text-orange-600">
							Để đảm bảo độ chính xác Luca AI sẽ chỉ đánh giá tuổi
							phát triển cho một lĩnh vực khi lĩnh vực đó có từ 5
							mục tiêu trở lên.
						</div>
					</div>
				</div> -->
				<div class="text-neutral-500 mt-4">
					Bạn hãy điền các thông tin dưới đây để tạo Đánh giá phát
					triển cho trẻ
				</div>
				<div class="w-full mt-4">
					<div class="font-semibold text-neutral-600 mb-2">
						Kết luận/Chẩn đoán
					</div>
					<div
						v-for="(item, index) in conclusions"
						:key="index"
						class="select-tabs mb-6 flex items-center gap-6"
					>
						<Multiselect
							v-if="optionResult.length > 0"
							v-model="item.assessment_conclusion"
							:options="optionResult"
							:searchable="true"
							deselectLabel="Ấn đễ bỏ chọn"
							placeholder="Kết luận về tình trạng của h.s"
							selectLabel=""
							selectedLabel=""
						>
							<template #noResult>
								Không tìm thấy kết quả
							</template>
						</Multiselect>
						<DaIcon
							:class="
								conclusions.length > 1 &&
								index !== conclusions.length
									? 'text-yellow-600 hover:text-yellow-700 active:text-yellow-500 cursor-pointer'
									: 'text-neutral-300'
							"
							class="h-4 w-4"
							name="das--delete"
							@click="
								conclusions.length > 1 &&
									index !== conclusions.length &&
									removeConclusions(index)
							"
						/>
					</div>
					<div class="flex justify-end gap-6">
						<div
							class="
								font-semibold
								text-yellow-700
								mb-2
								text-sm text-right
								cursor-pointer
							"
							@click="addConclusions"
						>
							Thêm chẩn đoán
						</div>
						<div class="h-4 w-4" style="min-width: 8px"></div>
					</div>
				</div>
				<div class="w-full mt-5">
					<div class="font-semibold text-neutral-600 mb-2">
						Ngày tháng năm sinh
					</div>
					<div class="select-tabs mb-6">
						<div class="input-group w-full">
							<VueDatepicker
								v-model="dob"
								:enableTimePicker="false"
								:maxDate="new Date()"
								autoApply
								class="input-date w-full"
								format="dd/MM/yyyy"
								placeholder="Ngày tháng năm sinh"
								uid="filter-by-date"
							>
								<template #input-icon>
									<svg
										fill="none"
										height="20"
										viewBox="0 0 20 20"
										width="20"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											clip-rule="evenodd"
											d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
											fill="#94A3B8"
											fill-rule="evenodd"
										/>
									</svg>
								</template>
							</VueDatepicker>
						</div>
					</div>
				</div>
			</div>
			<div class="px-6 py-4 border-t border-yellow-50">
				<div class="flex justify-end">
					<div>
						<button
							:disabled="!dob || !conclusions.length || disabled"
							class="button-p text-center w-32"
							type="button"
							@click="submit"
						>
							Tiếp tục
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { $api } from '@/services';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import LoadingDowloadPDF from '@/views/plansDetail/features/reportTarget/loadingDowloadPDF/loadingDowloadPDF.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import { OPTION_RESULT } from '@/data/optionResult';

const emit = defineEmits(['submit']);
const store = useStore();
const route = useRoute();
const id = ref(route.params.id);
const formId = ref(route.query.formId);
const props = defineProps(['student', 'startDate', 'endDate', 'isShow']);
const dob = ref(props.student?.student?.dob);
const conclusions = ref(props.student?.assessment_conclusions);
const disabled = ref(false);
const modalIsOpen = ref(false);

watch(
	() => props.isShow,
	() => {
		dob.value = props.student?.student?.dob;
		conclusions.value = props.student?.assessment_conclusions;
	},
	{ deep: true }
);

// watch(dob, (value) => {
// 	dob.value = value.toISOString().split('T')[0];
// });

function removeConclusions(index) {
	conclusions.value.splice(index, 1);
}

function addConclusions() {
	const today = new Date();
	conclusions.value.push({
		assessment_conclusion: '',
		assessment_date: today.toISOString().split('T')[0],
	});
}

const formatDate = (date) => {
	const d = new Date(date);
	const year = d.getFullYear();
	const month = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

async function submit() {
	try {
		modalIsOpen.value = true;
		disabled.value = true;
		const res = formId.value
			? await $api.student.generateStudentFormByAi(
					id.value,
					Number(formId.value),
					{
						student_and_assessment_conclusion: {
							student: {
								...props.student.student,
								dob: formatDate(dob.value),
							},
							assessment_conclusions: conclusions.value,
						},
					}
			  )
			: await $api.student.generateNoteByAi(
					id.value,
					props.startDate,
					props.endDate,
					{
						student_and_assessment_conclusion: {
							assessment_conclusions: conclusions.value,
							student: {
								dob: formatDate(dob.value),
								id: route.params.id,
								name: props.student.student.name,
							},
						},
					}
			  );
		if (res) {
			modalIsOpen.value = false;
			disabled.value = false;
			emit('submit', res.data);
		}
	} catch (e) {
		modalIsOpen.value = false;
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

const optionResult = ref(OPTION_RESULT);
</script>

<style lang="scss" scoped>
@import '../../../../../assets/styles/responsive';

.side-over {
	width: 100vw;
	padding-left: 0;

	@include media-breakpoint-up(md) {
		width: 600px;
	}
}

.sideover-content {
	height: calc(100vh - 300px);
	overflow-y: auto;
	padding-bottom: 40px;
}
</style>
